import React, { Component } from 'react';
import { Modal, Button, message } from 'antd';
import ThirteenFLongPosReportChkResultGrid from './ThirteenFLongPosReportChkResultGrid';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

class ThirteenFLongPosReportChkResultDialog extends Component {

  refreshBtnOnClicked = () => {
    const {
      fundCode,
      dateString,
    } = this.props.thirteenFLongPosReportCheckResultControlModal;

    this.props.loadThirteenFLongPosReportCheckResult(fundCode, dateString);
  }

  render() {
    const {
      thirteenFLongPosReportCheckResultControlModal,
      loadThirteenFLongPosReportCheckResultActionStatus,
    } = this.props;

    const {
      isOpened,
    } = thirteenFLongPosReportCheckResultControlModal;

    let modalTitle = '13F Long Report Check Result';
    const isLoading = loadThirteenFLongPosReportCheckResultActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div>
        <Modal
          title={modalTitle}
          centered
          width={1200}
          visible={isOpened}
          onOk={() => this.props.resetThirteenFLongPosReportCheckResultModalDialog()}
          onCancel={() => this.props.resetThirteenFLongPosReportCheckResultModalDialog()}
          cancelButtonProps={{ hidden: true }}
          destroyOnClose={true}
          maskClosable={false}
          afterClose={this.modalClosedHandle}
        >
          <div style={{ marginBottom: 10 }}>
            <Button 
              onClick={this.refreshBtnOnClicked} 
              size='small'
              style={{ fontSize: 10 }}
              loading={isLoading}
              type='primary'>
              Refresh
            </Button>

          </div>
          
          <div style={{ height: 600 }}>
            <ThirteenFLongPosReportChkResultGrid {...this.props} />
          </div>
        </Modal>
      </div>
    );
  }
}

export default ThirteenFLongPosReportChkResultDialog;